import { networkRequest } from "../utils/api";

export const getProfile = () =>
  networkRequest({
    method: "get",
    url: "/user/details/profile",
  });
